import React from 'react';
import PropTypes from 'prop-types';
import { Formik } from 'formik';
import { removeEmpty } from 'utils/functions';
import { Button, Divider } from 'antd';
import { SubmitButton } from 'formik-antd';

import Client from 'containers/app/client';
import { getValidateStatus, getHelp } from 'utils/form';

// import FormActions from 'components/form-actions';
import schema from 'containers/worker/dbs-check/schema';
import StageProps from 'containers/worker/dbs-check/prop-types';

import DbsForm from 'containers/worker/dbs-check/dbs-form';

const DBSFormModal = ({ onSubmit, onBack, uid, initialValues }) => {
  const uploadTo = `user/${uid}/identityOfficialDocuments/`;
  const handleSubmit = async (values) => {
    try {
      await Client.db.doc(`users/${uid}`).set(
        {
          ...removeEmpty(values),
        },
        { merge: true }
      );
      onSubmit();
    } catch (e) {
      console.error(e);
    }
  };

  return (
    <Formik
      initialValues={initialValues}
      onSubmit={handleSubmit}
      validationSchema={schema}
    >
      {({ isSubmitting, values, errors, touched, ...rest }) => {
        const validateStatus = getValidateStatus(values, errors, touched);
        const help = getHelp(values, errors, touched);
        return (
          <DbsForm
            {...rest}
            values={values}
            validateStatus={validateStatus}
            help={help}
            uploadTo={uploadTo}
            isSubmitting={isSubmitting}
          >
            <Divider />
            <div className="form-actions">
              <Button size="large" onClick={onBack}>
                Cancel
              </Button>
              <SubmitButton
                type="primary"
                size="large"
                disabled={isSubmitting}
                loading={isSubmitting}
              >
                Save
              </SubmitButton>
            </div>
          </DbsForm>
        );
      }}
    </Formik>
  );
};

DBSFormModal.propTypes = {
  uid: PropTypes.string.isRequired,
  onSubmit: PropTypes.func.isRequired,
  onBack: PropTypes.func.isRequired,
  initialValues: StageProps.isRequired,
};

DBSFormModal.defaultProps = {
  // onSubmit: () => {},
};

export default DBSFormModal;
